require("core", "dev");
require("gui", "dev");
require("layout");
require("chart");

var urllib = require("url");
var pathlib = require("path");

require("inc/mylistitem.js");
require("inc/jsview.js");
require("inc/cssview.js");
require("inc/layoutview.js");
require("inc/configview.js");
require("inc/console_log.js");
require("inc/adddialog.js");
require("inc/addclassdialog.js");
require("inc/adddialogdialog.js");
require("inc/addlayoutdialog.js");
require("inc/addstylesheetdialog.js");
require("inc/addprocessdialog.js");
require("inc/adddatabasedialog.js");
require("inc/aboutdialog.js");
require("inc/dialog-filebrowser.js");
require("inc/dialog-newproject.js");
require("inc/dialog-forkproject.js");
require("inc/dialog-project-settings.js");
require("inc/dialog-settings.js");
require("inc/addwebsocketdialog.js");
require("inc/dialog-welcome.js");
require("inc/layout-controls.js");
require("inc/layout-projectbrowser.js");
require("inc/layout-properties.js");
require("inc/layout-resources.js");

require("css/jsview.css");
require("css/cssview.css");
require("css/layoutview.css");
require("css/configview.css");
require("css/console_log.css");
require("css/addclassdialog.css");
require("css/adddialogdialog.css");
require("css/addlayoutdialog.css");
require("css/addstylesheetdialog.css");
require("css/addprocessdialog.css");
require("css/aboutdialog.css");
require("css/dialog-filebrowser.css");
require("css/dialog-newproject.css");
require("css/dialog-forkproject.css");
require("css/dialog-settings.css");
require("css/addwebsocketdialog.css");
require("css/dialog-welcome.css");
require("css/layout-properties.css");

require("gui/jsview.json");
require("gui/cssview.json");
require("gui/layoutview.json");
require("gui/configview.json");
require("gui/console_log.json");
require("gui/addclassdialog.json");
require("gui/adddialogdialog.json");
require("gui/addlayoutdialog.json");
require("gui/addstylesheetdialog.json");
require("gui/addprocessdialog.json");
require("gui/adddatabasedialog.json");
require("gui/aboutdialog.json");
require("gui/dialog-filebrowser.json");
require("gui/dialog-newproject.json");
require("gui/dialog-forkproject.json");
require("gui/dialog-settings.json");
require("gui/addwebsocketdialog.json");
require("gui/dialog-welcome.json");
require("gui/layout-resources.json");
require("gui/layout-projectbrowser.json");
require("gui/layout-properties.json");
require("gui/layout-controls.json");

require("gui/index.json");
require("css/index.css");


new (Application.extend({
	init: function(p) {
		this.base(p);
		/*this.document_new();*/
		this.tab.firstChild.appendChild( new LayoutResources() );
		//this.tab.onchange = this.tab_change.bind(this);
		/*this.onmessage = this.onmessage_handler.bind(this);*/

		this.servers = new Map();
		this.connect();

		this.server = new (Connection.extend({
			init: function() {
				this.base();
				this.connect("$//jdesktop.com/admin.jss".format(top.location.protocol=="http:" ? "ws:" : "wss:"));
			},
			/* connection level suttfs */
			onclose: this.connection_close.bind(this),
			onopen: this.connection_open.bind(this),
			/* authentication stuffs */
			login_ok: this.account_login_ok.bind(this),
			login_fail: this.account_login_fail.bind(this),
			logout_ok: this.account_logout_ok.bind(this),
			account_registration_ok: this.account_registration_ok.bind(this),
			account_registration_fail: this.account_registration_fail.bind(this),
			account_updatewslist: this.account_updatewslist.bind(this),
			/* project management stuffs */
			onbuilt: this.project_build_ok.bind(this),
			onbuildfail: this.project_build_fail.bind(this),
			projectopened: this.project_open_ok.bind(this),
			project_open_fail: this.project_open_fail.bind(this),
			//project_fork_ok: this.project_fork_ok.bind(this),
			//project_fork_fail: this.project_fork_fail.bind(this),
			/* fileserver stuffs */
			fileserver_readfile_ok: this.fileserver_readfile_ok.bind(this),
			fileserver_readfile_fail: this.fileserver_readfile_fail.bind(this),
			fileserver_writefile_ok: this.fileserver_writefile_ok.bind(this),
			fileserver_writefile_fail: this.fileserver_writefile_fail.bind(this),
			fileserver_listdir_ok: function() {alert("ook");},
			fileserver_listdir_fail: function() {},
			addtoproject_ok: function() {},
			addtoproject_fail: function() {},
			update_service_status: this.update_service_status.bind(this)
		}))();
		
		if (application.arguments.registration) {
			this.account_registration();
		} else {
			this.account_login();
		}
		
		document.addEventListener("mousedown", function(event) {
			if ((application.activeElement instanceof Highlightarea) && (!(event.targetControl instanceof Highlightarea))) {
				event.preventDefault();
			}
		});


		this.projectBrowser = this.treeviewcontainer.appendChild( new LayoutProjectbrowser({"style": "height: 100%;"}) );
		this.projectProperties = this.treeviewcontainer.appendChild( new LayoutProperties({"style": "display: none; height: 100%;"}) );
		this.projectControls = this.treeviewcontainer.appendChild( new LayoutControls({"style": "display: none; height: 100%;"}) );

		this.project = this.projectBrowser;

		application.addEventListener("onprojectopen", this.onprojectopen_handler.bind(this));
		application.addEventListener("onprojectclose", this.onprojectclose_handler.bind(this));

		this.onprojectclose_handler();
	},
	/* configuration of the currently open project */
	project: null,
	/* currently reported issues, key: url, value: array of issues */
	errors: {},
	/* project files, key: url, value: document if open else null*/
	documents: {},
	counter: 0,
	connect: function() {
		var serverlist = localStorage.getItem("serverlist") ? JSON.parse(localStorage.getItem("serverlist")) : [];
		serverlist.forEach(function(domain) {
			var server = new Connection();
			server.update_service_status = this.update_service_status.bind(this, domain)
			server.connect("$//$/admin.jss".format(top.location.protocol=="http:" ? "ws:" : "wss:", domain));
			this.servers.set(domain, server);
		}, this);
	},
	document_new: function(event, type, src, url) {
		type = type ? type : 0;
		src = src ? src : "";
		url = url ? url : "Unsaved document #" + this.counter++;

		if (!this.tab) {
			this.tab = this.tabcontainer.appendChild( new Tab() );
		}
		
		var item = new Tab.Item({
			'closable': true,
			'onremove': this.document_close.bind(this, url),
			'onremoved': this.document_close_done.bind(this, url),
			/*'icon': 'mimetypes text-plain',*/
			"icon": new Icon({"context": "mimetypes", "size": 16, "iconname": "text-plain"}),
			'title': 'Unsaved Document #'+(this.tab.childNodes.length+1)
		});
		
		var view = item.appendChild( new ({
			0: JSView,
			1: CSSView,
			2: LayoutView,
			3: ConfigView
		}[type])({
			'style': 'height:100%'
		}) );

		view.text = src;
		if (src=="" && url.startsWith("Unsaved document")) view.unsaved = true;
		
		view.onchange = this.document_change.bind(this);
		
			
		view.url = url;
		this.documents[url] = view;
		this.errors[url] = this.errors[url] ? this.errors[url] : [];
		item.title = url.split('/').last();
		
		if (this.errors[url].length) {
			this.errors[url].forEach(function(e) {
				if (this.documents[url].setComment) /* if document is commentable */
					this.documents[url].setComment(e[0]-1, e[1]);
			}, this);
		}

		this.tab.appendChild( item );
	},
	document_open: function() {
		this.dialog = new Dialog.FileBrowser({
			'onselect': function() {
				this.dialog.close()
				if (this.dialog.dialogResult == 'Cancel') {
					return;
				}
				this.document_open_do(this.dialog.url);
			}.bind(this)
		});
		this.dialog.show();
	},
	document_open_do: function(url, callback) {
		//if (this.activeDocument.unsaved && this.activeDocument.text=="")
		//	this.document_close_do(this.activeDocument.url);
		var urlobj = urllib.parse(url);
		var server = application.servers.get(urlobj.host);

		if (this.documents[url]) {
			this.documents[url].parentNode.select();
		} else {
			server.rcall("fileserver_readfile", urlobj.path);
			server.fileserver_readfile_ok = this.fileserver_readfile_ok.bind(this, url/*, callback*/);
		}
	},
	fileserver_readfile_ok: function(url, path, content) {
		var type;
		if (url.endsWith('.js')) type = 0;
		if (url.endsWith('.jss')) type = 0;
		if (url.endsWith('.jsss')) type = 0;
		if (url.endsWith('.css')) type = 1;
		if (url.endsWith('.json')) type = 2;
		if (url.endsWith('.japp')) type = 0;
		if (url.endsWith('.db')) type=0;
		
		this.document_new(null, type, content, url);
		
		if (typeof callback=="function") {
			callback.call(this);
		}
	},
	fileserver_readfile_fail: function(message) {
		new Dialog.Error({"text": message, "caption": "Build failed"}).show();
	},
	activeDocument: {
		get: function() {
			return(this.activeTab.firstChild);
		}
	},
	activeTab: {
		get: function() {
			return(this.tab.childNodes[this.tab.selectedIndex]);
		}
	},
	/* return an associative array, key: url value: document */
	openDocuments: {
		get: function() {
			var obj = {};
			this.tab.childNodes.forEach(function(e) {
				obj[e.firstChild.path] = e.firstChild;
			}, this);
			return(obj);
		}
	},
	document_change: function() {
		if (!this.activeDocument.unsaved)
			this.activeTab.title = "*"+this.activeTab.title;
		this.activeDocument.unsaved = true;
	},
	document_save_do: function(url) {
		var urlobj = urllib.parse(url);
		var server = application.servers.get(urlobj.host);

		server.fileserver_writefile_ok = this.fileserver_writefile_ok.bind(this, url);
		server.fileserver_writefile_fail = this.fileserver_writefile_fail.bind(this);
		server.rcall("fileserver_writefile", urlobj.path, this.activeDocument.text);
	},
	fileserver_writefile_ok: function(url, path) {
		if (!this.activeDocument.url) {
			this.activeDocument.url = url;
			this.activeTab.title = url.split("/").last();
		} else {
			this.activeTab.title = this.activeTab.title.replace('*', '');
		}
		this.activeDocument.unsaved = false;
	},
	fileserver_writefile_fail: function(message) {
		new Dialog.Error({"text": message, "caption": "Write Fail"}).show();
	},
	document_save: function() {
		if (!this.authenticated) {
			this.account_login();
			return;
		}
	
		if (this.activeDocument.url) {
			this.document_save_do(this.activeDocument.url);
			return;
		}

		this.dialog = new Dialog.FileBrowser({
			'title': 'Save As...',
			'url': 'http://jdesktop.com/users/'+this.username.text,
			'onselect': function() {
				this.dialog.close();

				if (this.dialog.dialogResult == 'Cancel') {
					return;
				}

				this.document_save_do(this.dialog.url);
			}.bind(this),
			"server": this.server
		});
		this.dialog.show();
	},
	document_close: function(url, event) {
		url = url ? url : this.activeDocument.url;
		if (this.activeDocument.unsaved) {
			var dialog = new Dialog.Confirm({
				'text': '<b>Save changes to document '+this.activeTab.title+' before closing?</b><br/>If you don\'t save, changes since the last save will be permanently lost.',
				'onchange': function() {
					if (dialog.dialogResult == 'Ok') {
						this.document_save();
					} else {
						this.document_close_do(url);
					}
				}.bind(this)
			}).show();
		} else {
			this.document_close_do(url);
		}
		return(false);
	},
	document_close_all: function() {
		for (var document in this.documents)
			this.document_close_do(document);
		this.document_new();			
	},
	document_close_do: function(url) {
		if (this.documents[url])
			this.documents[url].parentNode.remove();
		this.documents[url] = null;
	},
	document_close_done: function() {
		if (!this.tab.childNodes.length) {
			this.document_new();
			this.removeChild(this.tab);
		}
	},
	document_save_all: function() {
	},
	edit_undo: function() {
		/*document.execCommand("copy");*/
	},
	edit_redo: function() {
	},
	edit_copy: function() {
		var selObj = window.getSelection();
		this.clipboard = selObj.toString();
	},
	edit_paste: function() {
		if (this.clipboard && application.activeElement instanceof Highlightarea) {
			application.activeElement.insertText(this.clipboard);
		}
	},
	edit_server_list: function() {
		new Dialog.DialogSettings();
	},
	view_gui_controls: function() {
	},
	view_project_browser: function() {
		this.mylayout.left.closed = !this.mylayout.left.closed;
		this.view_project_browser_button.icon.iconname = this.mylayout.left.closed ? "" : "dialog-ok";
		this.buttonHideProjectBrowser.icon.iconname = this.mylayout.bottom.closed ? "draw-triangle2" : "draw-triangle1";
	},
	view_console: function() {
		this.mylayout.bottom.closed = !this.mylayout.bottom.closed;
		this.view_console_button.icon.iconname = this.mylayout.bottom.closed ? "" : "dialog-ok";
		this.buttonHideConsole.icon.iconname = this.mylayout.bottom.closed ? "draw-triangle3" : "draw-triangle4";
	},
	view_gui_properties: function() {
	},
	project_new: function() {
		new Dialog.NewProject();
	},
	project_fork: function() {
		new Dialog.ForkProject();
	},
	project_open: function() {
		this.dialog = new Dialog.FileBrowser({
			'title': 'Open Files',
			'url': 'http://jdesktop.com/users/'+this.username.text,
			'onselect': function() {
				this.dialog.close()
				if (this.dialog.dialogResult == 'Cancel') {
					return;
				}
				this.project_open_do(this.dialog.url);
			}.bind(this),
			"username": this.username.text
		});
		this.dialog.show();
	},
	project_icons: {
		"inc": "mimetypes application-javascript",
		"pss": "mimetypes application-javascript",
		"css": "mimetypes text-css",
		"gui": "mimetypes application-xml",
		"lib": "mimetypes package-x-generic",
		"srv": "mimetypes application-javascript",
		"dbs": "mimetypes package-x-generic"
	},
	project_open_do: function(url) {
		this.project_url = url;
		this.project_dir = url;

		url = urllib.parse(url);

		var server = application.servers.get(url.host);
		server.projectopened = this.project_open_ok.bind(this);
		server.project_open_fail = this.project_open_fail.bind(this);
		server.rcall("openproject", url.path);
	},
	projectAddResource: function(url) {
		this.errors[url] = [];
		var type = url.split("/")
		type = type[type.length-2];
		this.project[type].appendChild( new MyListItem({
			"text": url.split("/").last(),
			"icon": new Icon({
			"context": "mimetypes",
			"size": 16,
			"iconname": {
				"inc": "application-javascript",
				"pss": "application-javascript",
				"css": "text-css",
				"gui": "application-xml",
				"lib": "package-x-generic",
				"srv": "application-javascript",
				"dbs": "application-vnd.ms-access"
			}[type]
		}),
		"onclick": function(event, url) {
			/* if you click on the listitem we will open the related file, if it is open we focus that */
			this.document_open_do(url);
			}.bind(this, url)
		}) );
	},
	project_open_ok: function(project, original) {
		this.project_json = original;

		this.button_project_run.disabled = false;
		this.buttonProjectSave.disabled = false;
		
		//this.document_open_do(this.project_dir+"/gui/index.json");
		this.document_open_do(this.project_dir+"/inc/index.js");

		application.dispatchEvent( new CustomEvent("onprojectopen", {
			detail: project
		}) );
	},
	onprojectopen_handler: function(event) {
		this.buttonProjectNew.disabled = false;
		this.buttonProjectNew2.disabled = false;
		this.buttonProjectFork.disabled = false;
		this.buttonProjectOpen.disabled = true;
		this.buttonProjectOpen2.disabled = true;
		this.buttonProjectSettings.disabled = false;
		this.buttonProjectClose.disabled = false;
		this.buttonAddClass.disabled = false;
		this.buttonAddDialog.disabled = false;
		this.buttonAddLayout.disabled = false;
		this.buttonAddStylesheet.disabled = false;
		this.buttonAddProcess.disabled = false;
		this.buttonAddWebSocket.disabled = false;
		this.buttonAddDatabase.disabled = false;
	},
	onprojectclose_handler: function(event) {
		this.buttonProjectNew.disabled = false;
		this.buttonProjectNew2.disabled = false;
		this.buttonProjectFork.disabled = false;
		this.buttonProjectOpen.disabled = false;
		this.buttonProjectOpen2.disabled = false;
		this.buttonProjectSettings.disabled = true;
		this.buttonProjectClose.disabled = true;
		this.buttonAddClass.disabled = true;
		this.buttonAddDialog.disabled = true;
		this.buttonAddLayout.disabled = true;
		this.buttonAddStylesheet.disabled = true;
		this.buttonAddProcess.disabled = true;
		this.buttonAddWebSocket.disabled = true;
		this.buttonAddDatabase.disabled = true;
	},
	project_open_fail: function(message) {
		new Dialog.Error({"text": message, "caption": "Open Fail"}).show();
	},
	project_add_class: function() {
		new AddClassDialog({
			parent: this
		}).show();
	},
	project_add_dialog: function() {
		/*new AddDialogDialog({
			parent: this
		}).show();*/
	},
	project_add_gui: function() {
		new AddLayoutDialog({
			parent: this
		}).show();
	},
	project_add_css: function() {
		new AddStylesheetDialog({
			parent: this
		}).show();
	},
	project_add_process: function() {
		new AddProcessDialog({
			parent: this
		}).show();
	},
	project_add_websocket: function() {
		new AddWebSocketDialog({
			parent: this
		}).show();
	},
	project_add_database: function() {
		new AddDatabaseDialog({
			parent: this
		}).show();
	},
	project_settings: function() {
		new Dialog.ProjectSettings();
	},
	project_update_ok: function() {
	},
	project_update_fail: function(msg) {
	},
	project_close: function() {
		application.dispatchEvent( new CustomEvent("onprojectclose", {}) );

		this.button_project_run.disabled = true;
		this.buttonProjectSave.disabled = true;
		
		this.document_close_all();
	},
	/* input: html source document ,output: html document */
	project_build: function() {

	},
	project_download: function() {
		var urlobj = urllib.parse(this.project_url);
		var server = application.servers.get(urlobj.host);
		server.project_pack_ok = function(base64) {
			var link = document.createElement('a');
			if (typeof link.download === 'string') {
				link.href = "data:application/tar;base64,"+base64;
				link.download = pathlib.basename(urlobj.pathname) + ".tar";
				//link.download = "project.tar";

				//Firefox requires the link to be in the body
				document.body.appendChild(link);
    
				//simulate click
				link.click();

				//remove the link when done
				document.body.removeChild(link);
			} else {
				window.open(url);
			}
		};
		server.project_pack_fail = function() {};
		server.rcall("project_pack", urlobj.path);
	},
	project_run: function() {
		var url = this.activeDocument.url;
		var urlobj = urllib.parse(this.activeDocument.url);
		var server = application.servers.get(urlobj.host);

		if (this.activeDocument.url.endsWith(".jss")) {
			server.rcall("service_start", urlobj.path);
			return;
		}

		if (this.app) {
			this.button_project_run.icon.iconname = "arrow-right";
			this.button_project_run.text = "Run";
			try {
				this.app.onunload = null;
				this.app.close();
			} catch(e) {
			}
			delete this.app;
			return;
		}
		/* TODO build on client side, use protocol independent url-s */
		/*	foo://example.com:8042/over/there?name=ferret#nose  */
		/*	\__/ \___________________/\_________/ \_____________/ \__/     */
		 /*	 |                      |                      |                    |             |       */
		 /*   scheme          authority           path             query   fragment */
		
		
		/* running the project causes to delete all the marked errors in each document */
		Object.keys(this.errors).forEach(function(url) {
			this.errors[url] = [];
		}, this);
		
		/* unmark each code editor */
		Object.keys(this.documents).forEach(function(url) {
			if (this.documents[url] && this.documents[url].uncomment) {
				this.documents[url].uncomment();
			}
		}, this);
		
		/* delete error numbers */
		this.project.inc.childNodes.forEach( function(e) {
			e.num = 0;
		}, this);
		
		this.clearConsole();

		server.rcall("build", urlobj.path);
		this.logmessage("information", null, null, "Build application at $ . . .".format(this.project_url));
	},
	clearConsole: function() {
		while(this.console.childNodes.length)
			this.console.removeChild(this.console.firstChild);
	},
	project_build_ok: function() {
		var path = this.project_url.split("/");
		path.pop();
		path = path.join("/");
		this.logmessage("information", null, null, "Done. Application started.");
		/* Never access cached files by using traditional GET parameters (like other-cached-page.html?parameterName=value). */
		/* This will make the browser bypass the cache and attempt to get it from network. To link to cached resources that have  */
		/*  parameters parsed in JavaScript use parameters in the hash part of the link, such as */
		 /* other-cached-page.html#whatever?parameterName=value. */
		this.app = window.open(path+"#?debug=1", "","status=0,toolbar=0,location=0,directories=0");
		this.button_project_run.icon.iconname = "process-stop";
		this.button_project_run.text = "Stop";
		this.app.onunload = this.project_onclose.bind(this);
		this.app.onBeforeUnload = this.project_onclose.bind(this);
	},
	project_build_fail: function(message) {
		new Dialog.Error({"text": message, "caption": "Build failed"}).show();
	},
	project_onclose: function() {
		//if (this.app.location=="about:blank") return;
		this.button_project_run.icon.iconname = "arrow-right";
		this.button_project_run.text = "Run";
		delete this.app;
		this.logmessage("information", null, null, "Application terminated.");
	},
	project_browser_update: function() {
	},
	help_about: function() {
		 new AboutDialog();

	},
	buttonShowProjectBrowser_click: function(event) {
		this.projectBrowser.style.display = "";
		this.projectProperties.style.display = "none";
		this.projectControls.style.display = "none";
	},
	buttonShowProperties_click: function(event) {
		this.projectBrowser.style.display = "none";
		this.projectProperties.style.display = "";
		this.projectControls.style.display = "none";
	},
	buttonShowControls_click: function(event) {
		this.projectBrowser.style.display = "none";
		this.projectProperties.style.display = "none";
		this.projectControls.style.display = "";
	},
	/* functions called by cross window */
	childerror: function(message) {
		this.logmessage(message.type, message.url, message.line, message.message);

		this.errors[message.url].push([message.line, message.message]);
		
		this.project.inc.childNodes.forEach( function(e) {
			if (message.url.endsWith(e.text)) {
				e.num += 1;
			}
		}, this);
		
		/* if the document that caused the error is open then we mark the appropriate line */
		if (this.documents[message.url]) {
			if (this.documents[message.url].setComment) {/* if document is commentable */
				if (!this.documents[message.url].hasComment(message.line) )  {
						this.documents[message.url].setComment(message.line, message.message);
				}
			}
 		}
	},
	logmessage: function(type, url, line, message) {
		 var lg = new ConsoleLog({
			"type": type,
			"url": [url, line],
			"message": message,
			"url_click": function() {
				this.document_open_do(url, function(url, line) {
					this.documents[url].scrollLine = line-5;
				}.bind(this, url, line))
			}.bind(this, url, line)
		});

		if (this.console.childNodes.length) {
			this.console.insertBefore(lg, this.console.firstChild);
		} else {
			this.console.appendChild(lg);
		}
	},
	account_login: function() {
		this.authenticate_dialog = new Dialog.Authenticate({
			"onchange": function() {
				if (this.authenticate_dialog.dialogResult == "Ok") {
					this.account_login_do(this.authenticate_dialog.username, this.authenticate_dialog.password);
				} else {
					this.close();
					top.location = "http://jdesktop.com";
				}
			}.bind(this)
		});
		this.authenticate_dialog.show();
	},
	account_logout: function() {
		this.account_logout_do();
	},
	account_logout_do: function() {
		this.server.rcall("logout");
	},
	account_logout_ok: function() {
		this.authenticated = false;
		this.username.text = "nobody";
		/*this.account_login_item.style.display = "";*/
		/*this.account_logout_item.style.display = "none";*/
		this.account_login();
	},
	account_information: function() {
	},
	account_login_do: function(username, password) {
		this.server.rcall("login", username, password);
	},
	authenticated: false,
	account_login_ok: function(username) {
		this.authenticated = true;
		this.username.text = username;
		/*this.account_login_item.style.display = "none";*/
		/*this.account_logout_item.style.display = "";*/
		this.authenticate_dialog.close();
	},
	account_login_fail: function() {
		this.authenticate_dialog.style.animation = "shake 50ms 3 linear";
		this.authenticate_dialog.label.text = "Invalid username or password";
		this.authenticate_dialog.addEventListener("animationend", function() {
			this.authenticate_dialog.style.animation = "";
		}.bind(this));
		this.authenticate_dialog.label.style.backgroundColor = "#FFEBE9";
		this.authenticate_dialog.label.style.border = "solid #CC0000 1px";
	},
	account_registration: function() {
		this.dialog_registration = new Dialog.Registration({
			"onchange": this.account_registration_do.bind(this)
		});
		this.dialog_registration.show();
	},
	account_registration_do: function() {
		if (this.dialog_registration.dialogResult = "Ok") {
			this.server.rcall("registration", this.dialog_registration.username, this.dialog_registration.password, "email");
		} else {
			/*this.close();*/
			top.location = "http://jdesktop.com";
		}
	},
	account_registration_ok: function() {
		this.dialog_registration.close();
		this.account_login_do(this.dialog_registration.username, this.dialog_registration.password);
	},
	account_registration_fail: function(msg) {
		this.dialog_registration.label.style.backgroundColor = "#FFEBE9";
		this.dialog_registration.label.style.border = "solid #CC0000 1px";
		this.dialog_registration.label.text = msg;	
	},
	account_updatewslist: function(list) {
		alert("update");
		list = JSON.parse(list);
		var a = this.tab.firstChild;
		while (a.resources_websockets.childNodes.length)
			a.resources_websockets.removeChild(a.resources_websockets.firstChild);
		
		/* here we update the list of websockets */
		var cpuUsage = 0;
		list.forEach(function(item) {
			var row = new DataTable.Row();
			row.appendChild( new DataTable.Cell({"value": item.pid}) );
			row.appendChild( new DataTable.Cell({"value": item.request}) );
			row.appendChild( new DataTable.Cell({"value": item.utime}) );
			row.appendChild( new DataTable.Cell({"value": item.stime}) );
			row.appendChild( new DataTable.Cell({"type": "number", "format": "0.# %", "value": item.percentage*100}) );
			cpuUsage += item.percentage;
			a.resources_websockets.appendChild( row );
		}.bind(this));
		
		a.progressbarCPUUsage.value = cpuUsage;
		
	},
	updatewslist: function() {
		this.server.rcall("account_wslist");
	},
	connection_close: function(event) {
		this.account_logout_ok();
		new Dialog.Error({
			"text": "Lost connection to server: $".format(event.code)
		}).show();
	},
	connection_open: function() {
		if(application.arguments.openproject) {
			this.project_open_do(application.arguments.openproject);
		}
	},
	update_service_status: function(host, processList) {
		application.dispatchEvent( new CustomEvent("onservicestatuschange", {detail: {
			host: host,
			processList: processList
		}}) );
	},
	tab_change: function(event) {
		if (this.activeTab.title.endsWith(".jss")) {
			this.button_project_run.text = "Start Service";
		} else {
			this.button_project_run.text = "Run";
		}
	}
}))();